import React from "react";
import MenuItem from "@mui/material/MenuItem";
import {
  Button,
  ClickAwayListener,
  Grow,
  MenuList,
  Paper,
  Popper,
} from "@mui/material";
import LanguageIcon from "@mui/icons-material/Language";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { SUPPORTED_LANGUAGE_CODES } from "../../utilities/i18n";
import { useTranslation } from "react-i18next";
import { analytics } from "../../services/firebase";

export const LanguageMenu = () => {
  const { t, i18n } = useTranslation("languages");
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef<HTMLButtonElement>(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleListKeyDown = (event: React.KeyboardEvent<HTMLUListElement>) => {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    }
  };
  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current?.focus();
    }

    prevOpen.current = open;
  }, [open]);

  const handleCodeLngClicked = (lng: string) => {
    i18n.changeLanguage(lng);
    analytics.setUserProperties({ language: lng });
    setOpen(false);
  };

  return (
    <div>
      <Button
        ref={anchorRef}
        aria-controls={open ? "menu-list-grow" : undefined}
        aria-haspopup="true"
        onClick={handleToggle}
      >
        <>
          <LanguageIcon />
          <p>{i18n.resolvedLanguage}</p>
          <ExpandMoreIcon />
        </>
      </Button>
      <Popper
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
      // disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === "bottom" ? "center top" : "center bottom",
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList
                  autoFocusItem={open}
                  id="menu-list-grow"
                  onKeyDown={handleListKeyDown}
                >
                  {SUPPORTED_LANGUAGE_CODES.map((code, index) => {
                    const [baseLanguageCode, specificCountryCode] = code.split('-');

                    return (
                      <MenuItem
                        key={`${index}-${code}`}
                        selected={code === i18n.resolvedLanguage}
                        onClick={() => handleCodeLngClicked(code)}
                        style={{ textTransform: 'capitalize' }}
                      >
                        {!!specificCountryCode ?
                          `${t(baseLanguageCode, { lng: code, fallbackLng: baseLanguageCode })} | ${t(`${specificCountryCode.toLowerCase()}.name`, { lng: code, fallbackLng: baseLanguageCode, ns: "countries" })} (${t(baseLanguageCode)})`
                          : `${t(code, { lng: code })} (${t(code)})`
                        }
                      </MenuItem>
                    )
                  })}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </div>
  );
};
